module.exports = __webpack_public_path__ + "img/accessory_item_11.cbb9940c.svg";